module.exports = __webpack_public_path__ + "static/media/cover-ergonomic-design-of-workstations.89318d0a.jpg";